import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MODULE_ROUTES } from '../routes';
import { DwLayoutDefaultComponent, DwSsoLoginComponent } from '@webdpt/framework';
import { dwAttachTabbedRoutes } from '@webdpt/framework';
// import { FxLayoutDefaultComponent } from '../implementation/shared/layout/layout-default/layout-default.component';
import { Fxed020S01Component } from 'app/implementation/programs/e/fxed020/fxed020-s01.component'

const routes: Routes = [
  // {
  //   path: '',
  //   pathMatch: 'prefix',
  //   // component: Fxed020S01Component,
  //   loadChildren: './programs/e/fxed020/fxed020.module#Fxed020Module',
  //   // children: [
  //   //   //dwAttachTabbedRoutes(MODULE_ROUTES),
  //   //   ...MODULE_ROUTES
  //   // ]
  // },
  {
    path: '',
    pathMatch: 'prefix',
    loadChildren: './programs/mall/mall.module#MallModule',
    // children: [
    //   //dwAttachTabbedRoutes(MODULE_ROUTES),
    //   ...MODULE_ROUTES
    // ]
  },
  // {
  //   path: 'login',
  //   pathMatch: 'full',
  //   loadChildren: './auth/login.module#LoginModule'
  // },
  // {
  //   path: 'forget',
  //   pathMatch: 'full',
  //   loadChildren: './auth/forget/forget.module#ForgetModule'
  // },
  {
    path: 'sso-login',
    pathMatch: 'full',
    component: DwSsoLoginComponent
  },
  { path: '', redirectTo: '/mall/mallhome', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ImplementationRoutingModule { }
